<template>
  <router-view />
</template>
<script>
export default {
  name: 'Support',
};
</script>
